/**
 * Simple SPA Router for Filmssavn Admin
 */

class Router {
  constructor() {
    this.routes = {};
    this.currentRoute = null;
    this.params = {};

    window.addEventListener('popstate', () => this.handleRoute());

    document.addEventListener('click', (e) => {
      if (e.target.matches('[data-link]') || e.target.closest('[data-link]')) {
        e.preventDefault();
        const link = e.target.matches('[data-link]') ? e.target : e.target.closest('[data-link]');
        this.navigate(link.getAttribute('href'));
      }
    });
  }

  addRoute(path, handler) {
    this.routes[path] = handler;
  }

  navigate(path) {
    window.history.pushState({}, '', path);
    this.handleRoute();
  }

  async handleRoute() {
    const path = window.location.pathname;

    if (this.routes[path]) {
      this.currentRoute = path;
      this.params = {};
      await this.routes[path](this.params);
      return;
    }

    for (const [pattern, handler] of Object.entries(this.routes)) {
      const params = this.matchRoute(pattern, path);
      if (params) {
        this.currentRoute = pattern;
        this.params = params;
        await handler(params);
        return;
      }
    }

    this.navigate('/');
  }

  matchRoute(pattern, path) {
    const patternParts = pattern.split('/');
    const pathParts = path.split('/');

    if (patternParts.length !== pathParts.length) {
      return null;
    }

    const params = {};

    for (let i = 0; i < patternParts.length; i++) {
      const patternPart = patternParts[i];
      const pathPart = pathParts[i];

      if (patternPart.startsWith(':')) {
        const paramName = patternPart.slice(1);
        params[paramName] = pathPart;
      } else if (patternPart !== pathPart) {
        return null;
      }
    }

    return params;
  }

  init() {
    this.handleRoute();
  }
}

export const router = new Router();
